var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPageNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    fill: "white",
    stroke: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2158 18.7451L15.11 13.5784L10.3413 8.24081C10.2075 8.10433 10.1343 7.92728 10.136 7.74423C10.1345 7.54898 10.2178 7.36113 10.3677 7.22164C10.4412 7.15225 10.5291 7.0969 10.6263 7.05884C10.7235 7.02079 10.8281 7.00078 10.9338 7C11.0417 7.00199 11.148 7.02347 11.2466 7.06319C11.3453 7.10291 11.4343 7.16008 11.5085 7.23139L16.7849 13.0916C16.9248 13.2309 17.0017 13.4133 17 13.6022C16.9983 13.7911 16.9181 13.9723 16.7756 14.1095L11.3567 19.7734C11.2844 19.8448 11.1966 19.9019 11.0989 19.9409C11.0012 19.9799 10.8957 20 10.7891 20C10.6825 20 10.577 19.9799 10.4793 19.9409C10.3816 19.9019 10.2938 19.8448 10.2215 19.7734C10.0803 19.6336 10.0013 19.4509 10 19.2608C9.9987 19.0708 10.0751 18.8872 10.2144 18.7458",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageNext);
export default __webpack_public_path__ + "static/media/icon-page-next.64183654aaee907f0ea835325aa6519b.svg";
export { ForwardRef as ReactComponent };